module.exports = "/_next/static/images/dash-7dafaed4ac454396df99c255b196ad25.png";